import { render, staticRenderFns } from "./formSwitchItem.vue?vue&type=template&id=68b70055&scoped=true&"
import script from "./formSwitchItem.vue?vue&type=script&lang=js&"
export * from "./formSwitchItem.vue?vue&type=script&lang=js&"
import style0 from "./formSwitchItem.vue?vue&type=style&index=0&id=68b70055&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b70055",
  null
  
)

export default component.exports